"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ActionCreatorHelper", {
  enumerable: true,
  get: function get() {
    return _createReducer.ActionCreatorHelper;
  }
});
Object.defineProperty(exports, "SET_FIELD_DATA_AS_IS", {
  enumerable: true,
  get: function get() {
    return _createReducer.SET_FIELD_DATA_AS_IS;
  }
});
Object.defineProperty(exports, "autoGeneratedReducer", {
  enumerable: true,
  get: function get() {
    return _createReducer.autoGeneratedReducer;
  }
});
Object.defineProperty(exports, "createRootReducer", {
  enumerable: true,
  get: function get() {
    return _createReducer.createRootReducer;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _createReducer.default;
  }
});
Object.defineProperty(exports, "makeSetStoreField", {
  enumerable: true,
  get: function get() {
    return _createReducer.makeSetStoreField;
  }
});
Object.defineProperty(exports, "useSelectorNonNullable", {
  enumerable: true,
  get: function get() {
    return _useSelectorNonNullable.default;
  }
});

var _createReducer = _interopRequireWildcard(require("./createReducer"));

var _useSelectorNonNullable = _interopRequireDefault(require("./useSelectorNonNullable"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUNBOztBQVlBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHR5cGUgeyBBY3Rpb24sIFJlZHVjZXJPYmplY3QsIFJlZHVjZXJGdW5jdGlvbiwgUm9vdFJlZHVjZXIgfSBmcm9tICcuL2NyZWF0ZVJlZHVjZXInO1xuZXhwb3J0IHtcbiAgICBkZWZhdWx0LFxuICAgIGF1dG9HZW5lcmF0ZWRSZWR1Y2VyLFxuICAgIGNyZWF0ZVJvb3RSZWR1Y2VyLFxuICAgIG1ha2VTZXRTdG9yZUZpZWxkLFxuICAgIEFjdGlvbkNyZWF0b3JIZWxwZXIsXG4gICAgU0VUX0ZJRUxEX0RBVEFfQVNfSVMsXG59IGZyb20gJy4vY3JlYXRlUmVkdWNlcic7XG5cbmV4cG9ydCB0eXBlIHsgTWFrZVJvb3RTdGF0ZSB9IGZyb20gJy4vbWFrZVJvb3RTdGF0ZSc7XG5cbmV4cG9ydCB0eXBlIHsgTm9uTnVsbGFibGVSb290U3RhdGUgfSBmcm9tICcuL3VzZVNlbGVjdG9yTm9uTnVsbGFibGUnO1xuZXhwb3J0IHsgZGVmYXVsdCBhcyB1c2VTZWxlY3Rvck5vbk51bGxhYmxlIH0gZnJvbSAnLi91c2VTZWxlY3Rvck5vbk51bGxhYmxlJztcbiJdfQ==